// Highlight Categories nav item on all collection pages
(function() {
  function highlightCategoriesNav() {
    // Check if we're on a collection page (multiple ways to detect)
    const isCollectionPage = document.body.classList.contains('template-collection') || 
                             window.location.pathname.includes('/collections/');
    
    if (isCollectionPage) {
      // Find all navigation menu items
      const menuItems = document.querySelectorAll('.list-menu__item');
      
      menuItems.forEach(function(item) {
        const link = item.querySelector('a.header__menu-item');
        if (link) {
          const href = link.getAttribute('href');
          
          // Match "/collections" but not "/collections/specific-collection"
          if (href === '/collections' || href.endsWith('/collections')) {
            // Remove any existing active class from other items
            document.querySelectorAll('.list-menu__item--active').forEach(function(activeItem) {
              activeItem.classList.remove('list-menu__item--active');
            });
            
            // Add active class to Categories item
            item.classList.add('list-menu__item--active');
            link.classList.add('list-menu__item--active');
          }
        }
      });
    }
  }
  
  // Try multiple ways to ensure the script runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightCategoriesNav);
  } else {
    highlightCategoriesNav();
  }
  
  // Also run after a small delay to ensure all content is loaded
  setTimeout(highlightCategoriesNav, 100);
})();